import React, { useState } from "react";
import { range } from "lodash";
import { Typography } from "antd";

import { useInterval } from "./hook";
import styles from "./styles.less";

const { Title } = Typography;

export default () => {
  const [count, setCount] = useState(0);

  useInterval(() => {
    setCount((count + 1) % 4);
  }, 500);
  const dots = ".".repeat(count) + " ".repeat(4 - count);

  return (
    <div className={styles.loaderBody}>
      <div className={styles.comp}>
        <div className={styles.monitor}>
          <div className={styles.mid}>
            <div className={styles.site}>
              <div className={styles.topbar}>
                <div className={styles.cerrar}>
                  {range(0, 3).map(i => (
                    <div className={styles.circl} key={i} />
                  ))}
                </div>
              </div>
              <div className={styles.inhead}>
                <div className={styles.mid}>
                  <div className={styles.item} />
                </div>
                <div className={[styles.mid, styles.txr].join(" ")}>
                  {range(0, 4).map(i => (
                    <div className={styles.item} key={i} />
                  ))}
                </div>
              </div>
              <div className={styles.inslid} />
              <div className={styles.incont}>
                {range(0, 4).map(i => (
                  <div className={styles.item} key={i} />
                ))}
                <div className={styles.wid}>
                  {range(0, 3).map(i => (
                    <div className={styles.itwid} key={i}>
                      <div>
                        <div className={styles.contfoot} />
                      </div>
                    </div>
                  ))}
                  <div className={styles.clearfix} />
                </div>
                <div className={styles.infoot} />
              </div>
            </div>
          </div>
          <div className={[styles.mid, styles.codigo].join(" ")}>
            <div className={styles.line}>
              <div className={[styles.item, styles.var].join(" ")} />
              <div className={[styles.item, styles.cont].join(" ")} />
              <div className={styles.clearfix} />
            </div>
            <div className={styles.line}>
              <div className={[styles.item, styles.var].join(" ")} />
              <div className={[styles.item, styles.fun].join(" ")} />
              <div className={styles.clearfix} />
            </div>
            <div className={styles.line}>
              <div className={[styles.item, styles.var].join(" ")} />
              <div className={styles.clearfix} />
            </div>
            <div className={styles.line}>
              <div className={[styles.item, styles.var].join(" ")} />
              <div className={[styles.item, styles.atr].join(" ")} />
              <div className={[styles.item, styles.cont].join(" ")} />
              <div className={styles.clearfix} />
            </div>
            <div className={[styles.line, styles.tab1].join(" ")}>
              <div className={[styles.item, styles.min, styles.atr].join(" ")} />
              <div className={[styles.item, styles.lrg, styles.fun].join(" ")} />
              <div className={[styles.item, styles.min, styles.fun].join(" ")} />
              <div className={[styles.item, styles.lrg, styles.cont].join(" ")} />
              <div className={styles.clearfix} />
            </div>
            <div className={[styles.line, styles.tab1].join(" ")}>
              <div className={[styles.item, styles.min, styles.atr].join(" ")} />
              <div className={[styles.item, styles.min, styles.fun].join(" ")} />
              <div className={[styles.item, styles.lrg, styles.cont].join(" ")} />
              <div className={styles.clearfix} />
            </div>
            <div className={[styles.line, styles.tab1].join(" ")}>
              <div className={[styles.item, styles.atr].join(" ")} />
              <div className={[styles.item, styles.lrg, styles.fun].join(" ")} />
              <div className={[styles.item, styles.atr].join(" ")} />
              <div className={styles.clearfix} />
            </div>
            <div className={[styles.line, styles.tab1].join(" ")}>
              <div className={[styles.item, styles.min, styles.atr].join(" ")} />
              <div className={[styles.item, styles.min, styles.cont].join(" ")} />
              <div className={[styles.item, styles.lrg, styles.atr].join(" ")} />
              <div className={[styles.item, styles.fun].join(" ")} />
              <div className={styles.clearfix} />
            </div>
            <div className={[styles.line, styles.tab1].join(" ")}>
              <div className={[styles.item, styles.min, styles.atr].join(" ")} />
              <div className={[styles.item, styles.lrg, styles.fun].join(" ")} />
              <div className={[styles.item, styles.lrg, styles.cont].join(" ")} />
              <div className={[styles.item, styles.min, styles.fun].join(" ")} />
              <div className={styles.clearfix} />
            </div>
            <div className={[styles.line, styles.tab1].join(" ")}>
              <div className={[styles.item, styles.min, styles.var].join(" ")} />
              <div className={styles.clearfix} />
            </div>
            <div className={[styles.line, styles.tab1].join(" ")}>
              <div className={[styles.item, styles.min, styles.var].join(" ")} />
              <div className={styles.clearfix} />
            </div>
            <div className={[styles.line, styles.tab2].join(" ")}>
              <div className={[styles.item, styles.min, styles.var].join(" ")} />
              <div className={styles.clearfix} />
            </div>
            <div className={[styles.line, styles.tab2].join(" ")}>
              <div className={[styles.item, styles.min, styles.atr].join(" ")} />
              <div className={[styles.item, styles.min, styles.fun].join(" ")} />
              <div className={styles.clearfix} />
            </div>
            <div className={[styles.line, styles.tab3].join(" ")}>
              <div className={[styles.item, styles.min, styles.atr].join(" ")} />
              <div className={[styles.item, styles.min, styles.fun].join(" ")} />
              <div className={[styles.item, styles.lrg, styles.fun].join(" ")} />
              <div className={[styles.item, styles.lrg, styles.cont].join(" ")} />
              <div className={styles.clearfix} />
            </div>
            <div className={[styles.line, styles.tab3].join(" ")}>
              <div className={[styles.item, styles.min, styles.atr].join(" ")} />
              <div className={[styles.item, styles.min, styles.fun].join(" ")} />
              <div className={[styles.item, styles.lrg, styles.atr].join(" ")} />
              <div className={[styles.item, styles.lrg, styles.cont].join(" ")} />
              <div className={styles.clearfix} />
            </div>
            <div className={[styles.line, styles.tab4].join(" ")}>
              <div className={[styles.item, styles.min, styles.fun].join(" ")} />
              <div className={[styles.item, styles.lrg, styles.atr].join(" ")} />
              <div className={styles.clearfix} />
            </div>
            <div className={[styles.line, styles.tab1].join(" ")}>
              <div className={[styles.item, styles.atr].join(" ")} />
              <div className={[styles.item, styles.var].join(" ")} />
              <div className={[styles.item, styles.cont].join(" ")} />
              <div className={styles.clearfix} />
            </div>
            <div className={[styles.line, styles.tab4].join(" ")}>
              <div className={[styles.item, styles.min, styles.var].join(" ")} />
              <div className={styles.clearfix} />
            </div>
            <div className={[styles.line, styles.tab4].join(" ")}>
              <div className={[styles.item, styles.min, styles.atr].join(" ")} />
              <div className={[styles.item, styles.min, styles.fun].join(" ")} />
              <div className={[styles.item, styles.lrg, styles.atr].join(" ")} />
              <div className={[styles.item, styles.lrg, styles.cont].join(" ")} />
              <div className={styles.clearfix} />
            </div>

            <div className={styles.line}>
              <div className={[styles.item, styles.min, styles.var].join(" ")} />
              <div className={styles.clearfix} />
            </div>
          </div>
        </div>
        <div className={styles.base} />
      </div>
      <Title className={styles.loaderTitle} level={3}>
        Loading content
        <span className={styles.loadingDots}>{dots}</span>
      </Title>
    </div>
  );
};
